import React from 'react';
import { ZapIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function ProblemSection() {
  return <section className="w-full bg-cream-100 px-6 py-14 sm:py-16" aria-labelledby="problema-titulo" data-id="element-145" data-mp="2ltwb9qt06gw1">
      <div className="mx-auto max-w-5xl text-center" data-id="element-146" data-mp="30isglg3odfsy">
        <h2 id="problema-titulo" className="mx-auto max-w-3xl font-display text-3xl font-bold leading-[1.15] text-forest-800 sm:text-4xl lg:text-[2.9rem]" data-id="element-147" data-mp="2vqr4pvaf5r3g">
          ¿Cuántas clases más vas a preparar sobre Instrumentación sin tener el sistema completo?
        </h2>

        <p className="mx-auto mt-6 max-w-3xl text-base leading-relaxed text-forest-700/70 sm:text-lg" data-id="element-148" data-mp="3jftmr48ytlyh">
          Buscás contenido actualizado sin encontrar referencias claras. Y cuando un alumno pregunta sobre
          Industria 4.0, protocolos WirelessHART o cómo funciona el Edge Computing en la medición real, no tenés
          dónde buscar respuestas técnicas verificadas.
        </p>

        <p className="mx-auto mt-6 flex max-w-2xl items-start justify-center gap-3 rounded-2xl bg-cream-200/70 px-6 py-4 text-base font-medium text-forest-800" data-id="element-149" data-mp="jddeqewpsoyp">
          <ZapIcon className="mt-1 h-5 w-5 shrink-0 text-ember-500" aria-hidden="true" data-id="element-150" data-mp="ocga17mw7gth" />
          <span data-id="element-151" data-mp="sc8m3ubhw53l">
            No es falta de experiencia docente. Es que el material de instrumentación moderna no existe
            compilado en un solo lugar.
          </span>
        </p>

        <h3 className="mt-8 text-base font-medium text-forest-700/70" data-id="element-152" data-mp="122thz9zsavit">Esto quizás te está pasando hoy:</h3>

        <ul className="mt-5 grid gap-3 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-153" data-mp="1714p3cyp2rxc">
          {painPoints.map(({
          icon: Icon,
          title,
          description
        }) => <li key={title} className="flex h-full flex-col rounded-xl border border-cream-300/70 bg-cream-50 p-4 transition-[transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:shadow-card" data-id="element-154" data-mp="1g347o9pcy42e">
              <div className="flex items-center gap-2.5" data-id="element-155" data-mp="3hv0voispp6e2">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-forest-700" data-id="element-156" data-mp="ozh4wf1cv8nq">
                  <Icon className="h-3.5 w-3.5 text-ember-400" aria-hidden="true" data-id="element-157" data-mp="k27h13tm7520" />
                </span>
                <h4 className="text-sm font-semibold leading-tight text-forest-800" data-id="element-158" data-mp="y1qe91kw0vzj">{title}</h4>
              </div>
              <p className="mt-2.5 text-[0.8rem] leading-relaxed text-forest-700/70" data-id="element-159" data-mp="txsgovb7nt8l">{description}</p>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl font-display text-xl font-semibold italic leading-snug text-forest-700 sm:text-2xl" data-id="element-160" data-mp="130bev241xhoi">
          ¿Y si esta fuera la última semana que enseñás Instrumentación sin tener el ecosistema completo?
        </p>
      </div>
    </section>;
}